import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const COURSES = [
  { href: '#courses',     label: 'All Courses'       },
  { href: '#10th12th',    label: '10th / 12th Prep'  },
  { href: '#mba',         label: 'MBA Preparation'   },
  { href: '#board',       label: 'Board Exams'       },
  { href: '#competitive', label: 'Competitive Exams' },
];

const COMPANY = [
  { to: '/about-us',   label: 'About Us'    },
  { to: '/contact-us', label: 'Contact Us'  },
  { href: '#help',     label: 'Help Center' },
  { href: '#blog',     label: 'Blog'        },
];

const LEGAL = [
  { to: '/privacy-policy',             label: 'Privacy Policy'     },
  { to: '/terms-conditions',           label: 'Terms & Conditions' },
  { to: '/cancellation-refund-policy', label: 'Refund Policy'      },
];

const SOCIALS = [
  {
    label: 'Instagram',
    href: 'https://instagram.com',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162S8.597 18.163 12 18.163s6.162-2.759 6.162-6.163S15.403 5.838 12 5.838zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
      </svg>
    ),
  },
  {
    label: 'YouTube',
    href: 'https://youtube.com',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
      </svg>
    ),
  },
  {
    label: 'Twitter / X',
    href: 'https://twitter.com',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.254 5.622L18.244 2.25zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77z"/>
      </svg>
    ),
  },
  {
    label: 'Facebook',
    href: 'https://facebook.com',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>
    ),
  },
];

function FooterLink({ href, to, label }) {
  if (to) return <Link to={to}>{label}</Link>;
  return <a href={href}>{label}</a>;
}

/* Collapsible section for mobile */
function FooterAccordion({ title, children }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`footer-col footer-accordion${open ? ' footer-accordion--open' : ''}`}>
      <button
        className="footer-col-heading footer-accordion-btn"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
      >
        {title}
        <svg
          className="footer-accordion-icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          aria-hidden="true"
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>
      <div className="footer-accordion-body">
        {children}
      </div>
    </div>
  );
}

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer" aria-label="Site footer">

      {/* ── Top wave ── */}
      <div className="footer-wave" aria-hidden="true">
        <svg viewBox="0 0 1440 56" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0,28 C240,56 480,0 720,28 C960,56 1200,0 1440,28 L1440,56 L0,56 Z" fill="#0f172a" />
        </svg>
      </div>

      <div className="footer-body">
        <div className="footer-inner">

          {/* ════ BRAND ════ */}
          <div className="footer-brand">
            <Link to="/" className="footer-brand-link" aria-label="Ab Meri Baari — Home">
              <div className="footer-logo-wrap">
                <img src="/512-app-icon.png" alt="Ab Meri Baari" className="footer-logo" />
              </div>
              <span className="footer-brand-name">Ab Meri Baari</span>
            </Link>

            <p className="footer-tagline">
              Empowering every student with quality video lectures, smart quizzes,
              and personalised learning paths — anytime, anywhere.
            </p>

            <div className="footer-brand-bottom">
              {/* Contacts */}
              <div className="footer-contacts">
                <a href="mailto:support@abmeribaari.com" className="footer-contact-item">
                  <span className="footer-contact-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                      <polyline points="22,6 12,13 2,6"/>
                    </svg>
                  </span>
                  support@abmeribaari.com
                </a>
                <a href="tel:+919098099553" className="footer-contact-item">
                  <span className="footer-contact-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 10.8 19.79 19.79 0 01.02 2.22 2 2 0 012 .04h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 14.92v2z"/>
                    </svg>
                  </span>
                  +91-9098099553
                </a>
              </div>

              {/* Socials */}
              <div className="footer-socials">
                {SOCIALS.map((s) => (
                  <a
                    key={s.label}
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-social-btn"
                    aria-label={s.label}
                  >
                    {s.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* ════ LINK COLUMNS ════ */}
          <div className="footer-cols">

            {/* Courses */}
            <FooterAccordion title="Courses">
              <ul className="footer-col-list">
                {COURSES.map((c) => (
                  <li key={c.label}><FooterLink {...c} /></li>
                ))}
              </ul>
            </FooterAccordion>

            {/* Company */}
            <FooterAccordion title="Company">
              <ul className="footer-col-list">
                {COMPANY.map((c) => (
                  <li key={c.label}><FooterLink {...c} /></li>
                ))}
              </ul>
            </FooterAccordion>

            {/* App + Legal */}
            <FooterAccordion title="Get the App">
              <p className="footer-col-desc">
                Download for offline video lectures, quizzes &amp; personalised study plans.
              </p>
              <div className="footer-store-btns">
                <a
                  href="https://play.google.com/store"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-store-btn"
                  aria-label="Get it on Google Play"
                >
                  <svg className="footer-store-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M3.18 23.76c.3.17.64.24.98.21l.13-.08 11.05-6.38-2.39-2.39-9.77 8.64zm-1.02-20.5A1.83 1.83 0 002 4.5v15c0 .44.13.86.36 1.21l.1.1 8.4-8.4v-.2L2.16 3.26zm15.6 8.72-2.99-1.73-2.68 2.68 2.68 2.68 3.01-1.74c.86-.49.86-1.4-.02-1.89zM4.16.24l-.14-.08C3.68-.01 3.31.05 3 .22L12.87 10.1l2.39-2.39L4.16.24z"/>
                  </svg>
                  <span className="footer-store-text">
                    <span className="footer-store-small">GET IT ON</span>
                    <span className="footer-store-large">Google Play</span>
                  </span>
                </a>
                <a
                  href="https://apps.apple.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-store-btn"
                  aria-label="Download on the App Store"
                >
                  <svg className="footer-store-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                  </svg>
                  <span className="footer-store-text">
                    <span className="footer-store-small">DOWNLOAD ON THE</span>
                    <span className="footer-store-large">App Store</span>
                  </span>
                </a>
              </div>

              {/* Legal nested under app col */}
              <div className="footer-legal-block">
                <p className="footer-legal-title">Legal</p>
                <ul className="footer-col-list">
                  {LEGAL.map((l) => (
                    <li key={l.label}><FooterLink {...l} /></li>
                  ))}
                </ul>
              </div>
            </FooterAccordion>

          </div>{/* /footer-cols */}

          {/* ════ BOTTOM BAR ════ */}
          <div className="footer-bottom">
            <p className="footer-bottom-copy">
              &copy; {year} Ab Meri Baari. All rights reserved.
              <span className="footer-bottom-sep" aria-hidden="true">·</span>
              Made with <span aria-label="love">❤️</span> for every student.
            </p>
            <div className="footer-bottom-links">
              <Link to="/privacy-policy">Privacy</Link>
              <Link to="/terms-conditions">Terms</Link>
              <Link to="/cancellation-refund-policy">Refund</Link>
            </div>
          </div>

        </div>
      </div>
    </footer>
  );
}

export default Footer;
